export const fromContacts = contacts =>
  contacts.map(contact => ({
    value: contact.id,
    label: contact.firstName + ' ' + contact.lastName,
    phone: contact.phone,
    email: contact.email,
    isMain: true
  }))

export const toCategories = categories =>
  categories.map(category => ({
    value: category.id,
    label: category.name,
    system: category.system,
    code: category.code
  }))

export const toUserRole = user => ({
  ...user,
  id: user.user.value,
  user: {
    firstName: user.user.label.split(' ')[0],
    lastName: user.user.label.split(' ')[1],
    id: user.user.value
  }
})

export const fromTeamRoles = team => {
  return {
    teamRoles: team.map(t => ({
      userId: t.id,
      role: t.role.value
    }))
  }
}
